import '@adornis/chemistry/elements/components/stack/x-stack.js';
import { stateful, useObservable } from '@adornis/functional-lit/stateful';
import '@adornis/html-based-buildify/client/editor/x-editor';
import { html } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { subscribeCommentsByReference } from '../api/subscribeCommentsByReference';
import type { Comment } from '../db/Comment';
import { ContentComment } from '../db/ContentComment';
import { ViewComment } from './ViewComment';

export const ViewCommentsByReference = stateful(
  ({
    referenceID,
    onHover,
    globalSettingsClassName,
  }: {
    referenceID: string;
    onHover?: (comment: Comment) => void;
    globalSettingsClassName: string;
  }) => {
    const comments = useObservable(
      () =>
        subscribeCommentsByReference<ContentComment>(referenceID)({
          createdAt: 1,
          createdBy: 1,
          relatedEntityID: 1,
          updatedAt: 1,
          text: 1,
          contentID: 1,
        }),
      [referenceID],
    );

    return html`
      ${repeat(comments ?? [], comment =>
        ViewComment({
          globalSettingsClassName,
          // @ts-expect-error typing is correct
          comment,
          onHover: () => {
            onHover?.(comment);
          },
        }),
      )}
    `;
  },
);
